<template>
	<v-dialog
		v-model="open"
		fullscreen
		persistent
		transition="dialog-bottom-transition"
		style="overflow-x: hidden"
		scrollable>
		<v-card class="background-1 rounded-0" v-if="open">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Esita Scadenze</p>
				<v-spacer></v-spacer>
				<v-btn icon @click.native.stop="close()"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>

			<v-card-text style="overflow-x: hidden" class="pa-0">
				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Esito</strong>
						</v-col>
					</v-row>
					<v-card class="round-card background-2 pa-4 px-0 mt-6 pt-12">
						<fields-generator
							v-if="loaded"
							:fieldsset.sync="infoFieldsset"
							:model.sync="filters"
							ref="fieldsgenerator"
						></fields-generator>
						<v-row class="ma-0 px-6 pb-6">
							<small>
								<p>Con <strong>esito positivo</strong> viene registrato l'incasso sul conto finanziario scelto e la scadenza viene chiusa.</p>
								<p>Con <strong>esito negativo</strong> la scadenza diventa insoluta e non viene registrato alcun pagamento.</p>
							</small>
						</v-row>
					</v-card>
				</v-container>

				<v-container class="px-6" fluid>
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Scadenze da esitare</strong>
							<span class="grey--text pr-4">&nbsp;({{ deadlines.length }})</span>
							<div class="display-flex" v-if="skipped > 0">
								<strong>Escluse&nbsp;</strong>
								<span class="grey--text pr-4">&nbsp;({{ skipped }})</span>
							</div>
						</v-col>
					</v-row>
				</v-container>

				<v-container class="px-6" fluid>
					<v-card class="round-card background-2 pa-4">
						<v-row class="mx-0 py-2">
							<v-col class="pa-0" cols="12" sm="12" md="6" lg="3" v-for="deadline in deadlines" :key="deadline.id">
								<v-list two-line dense class="background-2 w100p py-0">
									<v-list-item @click="openNewTab(deadline.id)" @click.middle="openNewTab(deadline.id)">
										<v-list-item-action>
											<v-icon color="warning">mdi-bank-check</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title style="font-size: 12px !important">{{ deadline.name }} ({{ deadline.business_name }})</v-list-item-title>
											<v-list-item-subtitle>{{ deadline.amount | currency(2) }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
							<v-col class="pa-0" cols="12" sm="12" md="6" lg="3" v-if="deadlines.length == 0">
								<v-list two-line dense class="background-2 w100p py-0">
									<v-list-item>
										<v-list-item-content>
											<v-list-item-title style="font-size: 12px !important">Nessuna scadenza esitabile tra quelle selezionate</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row>
					</v-card>
					<small class="pl-2">Sono esitabili le scadenze RIBA o RID non ancora chiuse e senza un esito già registrato.</small>
				</v-container>
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="close()">Annulla</v-btn>
				<v-btn text color="primary" @click.native="validateFields()" :loading="sending" :disabled="deadlines.length == 0">Procedi</v-btn>
			</v-card-actions>
		</v-card>

		<confirm-dialog
			:confirmModel="confirmSettle"
			mainTitle="Confermi l'esito di queste scadenze?"
			secondTitle="Con esito positivo saranno registrati i pagamenti e le scadenze verranno chiuse; con esito negativo diventeranno insolute."
			@update:confirmModel="confirmSettle = false"
			:atConfirm="settleDeadlines"
			:confirm="{color: 'info', label: 'esita'}"
		></confirm-dialog>
	</v-dialog>
</template>

<script>

	export default {
		name: 'settle-deadlines',
		props: {
			params: Object,
			selected: Array,
			selectedIds: Array,
			modelDef: String,
			open: Boolean,
			button: Object,
		},

		data() {
			return {
				deadlines: [],
				infoFieldsset: [],
				filters: {},
				skipped: 0,
				sending: false,
				loaded: false,
				confirmSettle: false,
			}
		},

		watch: {
			open: {
				handler(newValue) {
					if(newValue) {
						this.getInfo()
					} else {
						this.reset()
					}
				}
			},
		},

		methods: {

			getData() {
				this.axios.post('settle-deadlines-data/', {ids: this.selectedIds, model: this.button.model}).then(response => {
					this.$set(this, 'deadlines', response.data.data)
					this.skipped = response.data.skipped
				}, () => {})
			},

			getInfo() {
				this.axios.get('settle-deadlines-info/').then(response => {
					this.infoFieldsset = response.data.fields

					_.forEach(this.infoFieldsset.fields, (value) => {
						if(value.type === 'checkbox') {
							this.$set(this.filters, value.key, '')
						}
						if(value.default) {
							this.$set(this.filters, value.key, value.default)
						}
					})

					this.loaded = true
					this.getData()
				}, () => {})
			},

			openNewTab(id) {
				const url = this.$router.resolve({ name: 'companydeadlines-show', params: { id: parseInt(id), ...this.params }}).href
				window.open(url, '_blank', 'noopener,noreferrer')
			},

			settleDeadlines() {
				this.sending = true

				let dataObject = {
					filters: this.filters,
					ids: this.deadlines.map((deadline) => {
						return deadline.id
					})
				}

				this.axios.post('settle-deadlines', dataObject).then(response => {
					this.sending = false
					this.$eventBusUtility.$emit('refreshTable_' + this.modelDef)
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
					this.close()
				}, () => {
					this.sending = false
				})
			},

			validateFields() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					} else {
						this.confirmSettle = true
					}
				}).catch(() => {})
			},

			reset() {
				this.deadlines = []
				this.filters = {}
				this.skipped = 0
				this.loaded = false
				this.sending = false
				this.confirmSettle = false
			},

			close() {
				this.reset()
				this.$emit('close')
			},
		},
	}
</script>
